import { createRootRoute, createRoute, createRouter, lazyRouteComponent, Outlet, redirect } from '@tanstack/react-router';
import NotFoundPage from './pages/NotFoundPage';

// Rotas do cliente: mesmos caminhos das telas mock que viviam na landing. Cada tela é um chunk próprio.
const rootRoute = createRootRoute({ component: Outlet, notFoundComponent: NotFoundPage });

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/app' });
  },
});
const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/entrar',
  component: lazyRouteComponent(() => import('./pages/LoginPage')),
});
const onboardingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/comecar',
  component: lazyRouteComponent(() => import('./pages/OnboardingPage')),
});
const appRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/app',
  component: lazyRouteComponent(() => import('./pages/AppPage')),
});
const securityRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/app/seguranca',
  component: lazyRouteComponent(() => import('./pages/SecurityPage')),
});
const signUpRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/cadastro',
  component: lazyRouteComponent(() => import('./pages/SignUpPage')),
});
const resetRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/redefinir-senha',
  component: lazyRouteComponent(() => import('./pages/ResetPasswordPage')),
});

const routeTree = rootRoute.addChildren([indexRoute, loginRoute, onboardingRoute, appRoute, securityRoute, signUpRoute, resetRoute]);

export const router = createRouter({ routeTree, defaultPreload: 'intent' });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
